export default __webpack_public_path__ + "static/1470-160bb61563aef95899cf48f4f542c03d.gif";